import { render, staticRenderFns } from "./DialogFooter.vue?vue&type=template&id=e0689bea&scoped=true&"
import script from "./DialogFooter.vue?vue&type=script&lang=js&"
export * from "./DialogFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0689bea",
  null
  
)

export default component.exports